import React, { useState,useRef } from "react";
import {  Input, Button } from "antd";

import { useLocation, useNavigate } from "react-router-dom";
import StackChart from "../StackChart";
import useSettingstore from "../../store/settings.store";

import "./table.scss";
import { getFieldStyle } from "../../themes";

export default function Table({
    isClickable = false,
    titleList,
    data,
    isJDPage = false,
    isQsetJDPage = false,
    isEvalPage = false,
    columnWidth = [50, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100],
    dontShowFreezeComunButton = false,
    currentProduct = "qhrflow"
}) {
  const { addOrUpdateSetting, getSettingByKey } = useSettingstore();
  const SETTING_KEY = "rtable_frozen_columns";
  const [frozenColumns, setFrozenColumns] = useState(() => {
    const saved = getSettingByKey(SETTING_KEY);
    return saved ? saved.value : 1;
  });

  const navigate = useNavigate();
  const inputRef = useRef(null);
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const parentPath = pathSegments[1];

  const handleFreezeChange = (e) => {
    const newValue = parseInt(e.target.value) || 0;

    // Update local UI state
    setFrozenColumns(newValue);

    // Persist to Zustand Store
    addOrUpdateSetting({
      key: SETTING_KEY,
      value: newValue,
    });
  };

  if (!data) {
    return (
      <div style={{ textAlign: "center", margin: "30px", fontSize: "12px" }}>
        No Updates in the selected duration
      </div>
    );
  }
  const GetJobID = (title) => {
    const jd_array = title?.split("]");
    var jdID = jd_array[0]?.replace("[", "");
    return jdID;
  };
  const handleJDClick = (title, rowIndex) => {
    if (isQsetJDPage) {
      navigate(`/qsethome/qsetjd/${GetJobID(title)}`);
    } else if (isEvalPage){
      var jobID = title; //not clean way to get job id from eval page
      navigate(`/${parentPath}/${jobID}`, {
        state: { newView: "eval", qhevid: data[rowIndex]?.evid },
      });
    } else {
      if(currentProduct==="nujobs"){
          navigate(`/${parentPath}/${GetJobID(title)}/nujobs`);
      }else{
          navigate(`/${parentPath}/${GetJobID(title)}`);
      }
    }
    };
   const handleResumeStatsClick = (id)=>{
      navigate(id)
   }
    const showPieChart = (tableInfo) =>{
        if( tableInfo === "available_resumes"){
            return true
        }
        else{
            return false
        }
    }    
  const getStickyStyle = (index, cellType) => {
    if (index >= frozenColumns) return {};

    // Calculate sum of widths of all previous columns to set the 'left' property
    const leftOffset = columnWidth
      .slice(0, index)
      .reduce((acc, curr) => acc + curr, 0);

    return {
      position: "sticky",
      left: `${leftOffset}px`,
      zIndex: 10,
      background: cellType === "title" ? "#99d2fd" : "#c0e4ff",
      boxShadow:
        index === frozenColumns - 1 ? "2px 0 5px -2px rgba(0,0,0,0.2)" : "none", // Adds a nice shadow line
    };
  };

  const gridTemplate = columnWidth.map((w) => `${w}px`).join(" ");

  return (
    <div className="table-wrapper">
      
      {
        dontShowFreezeComunButton?
        <>
        </>
        :<>
            <div
              className="freeze-control"
              style={{ marginBottom: "10px", position: "sticky", left: "0" }}
            >
              <span style={{ fontSize: "14px" }}>Freeze Columns: </span>
              <input
                type="number"
                min="0"
                max={titleList.length}
                value={frozenColumns}
                onChange={handleFreezeChange}
                style={{
                  width: "50px",
                  marginLeft: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
              />
            </div>        
        </>
      }

      <div
        className="table-title-wrapper"
        style={{
          gridTemplateColumns: gridTemplate,
        }}
      >
        {titleList.map((title, idx) => (
          <div className="table-title" style={getStickyStyle(idx, "title")}>
            {title}
          </div>
        ))}
      </div>
      {data?.map((table, rowIndex) => (
        <div
          onClick={
            isJDPage
              ? () => handleJDClick(table.title, rowIndex)
              : () => handleResumeStatsClick(table.team_member_id)
          }
          key={table.id}
          className="table-info-wrapper"
          style={{
            gridTemplateColumns: gridTemplate,
            cursor: isClickable && "pointer",
          }}
        >
          {Object.keys(table)?.map((tableInfo, idx) => (
            <div
              className="table-info"
              style={{
                ...getFieldStyle(tableInfo, table[tableInfo]),
                ...getStickyStyle(idx, "info"),
              }}
            >
              {showPieChart(tableInfo) ? (
                <div className="stackChart-wrapper">
                  <StackChart stackData={null} stack={true} />
                </div>
              ) : (
                table[tableInfo]
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
